import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import VideoCallRoom from '../components/VideoCallRoom';
import ResponsiveNavigation from '../components/ResponsiveNavigation';
import { useAuth } from '../contexts/AuthContext';

const VideoCall = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const roomUrl = searchParams.get('room');
  const token = searchParams.get('token');
  const applicationId = searchParams.get('applicationId');

  const handleLeave = () => {
    if (applicationId) {
      navigate(`/candidates/${applicationId}`);
    } else {
      navigate('/dashboard');
    }
  };

  if (!roomUrl) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center text-white">
          <p className="text-lg mb-2">No video call room specified</p>
          <button onClick={() => navigate('/dashboard')} className="text-blue-400 hover:underline">
            Return to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-gray-900" data-testid="video-call-page">
      <div className="flex-1">
        <VideoCallRoom
          roomUrl={roomUrl}
          token={token}
          userName={userProfile ? `${userProfile.firstName} ${userProfile.lastName}` : 'Participant'}
          onLeave={handleLeave}
        />
      </div>
    </div>
  );
};

export default VideoCall;
